/**
 * @fileoverview Custom hook for managing certificate form state
 */
import { useState, useCallback } from 'react';
import { validateCertificateForm } from '@/utils/validation';
import { getTodayDate } from '@/utils/formatters';
const getInitialFormData = () => ({
    beneficiaryName: '',
    idOrLicense: '',
    certificateType: 'Piloto Privado (PPL)',
    issueDate: getTodayDate(),
    expirationDate: '',
    notes: '',
});
export const useCertificateForm = () => {
    const [formData, setFormData] = useState(getInitialFormData());
    const [mode, setMode] = useState('pilot');
    const [errors, setErrors] = useState({});
    const updateField = useCallback((field, value) => {
        setFormData((prev) => ({ ...prev, [field]: value }));
        // Clear error for this field when user starts typing
        if (errors[field]) {
            setErrors((prev) => {
                const newErrors = { ...prev };
                delete newErrors[field];
                return newErrors;
            });
        }
    }, [errors]);
    const validate = useCallback(() => {
        const validation = validateCertificateForm(formData);
        setErrors(validation.errors);
        return validation.isValid;
    }, [formData]);
    const reset = useCallback(() => {
        setFormData(getInitialFormData());
        setErrors({});
    }, []);
    return {
        formData,
        mode,
        setMode,
        updateField,
        validate,
        reset,
        errors,
    };
};
